






















































































































import { DateRange, EventInfo, EventExtraInfo } from 'inscreva-sse-models';
import moment from 'moment';
import DatePicker from 'ss-commons-front/src/components/DatePicker.vue';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { EventDateHelper } from '../services/EventDateHelper';
import DateRangePicker from './DateRangePicker.vue';
import Timelines from './Timelines.vue';

@Component({
  components: {
    Timelines,
    DatePicker,
    DateRangePicker,
  },
})
export default class DateRangeListComponent extends Vue {
  @Prop()
  private interval?: boolean;

  @Prop({ required: true, default: () => [] as Array<DateRange> })
  private dates: Array<DateRange>;

  @Prop()
  private parentInfo?: EventExtraInfo & EventInfo;

  @Prop()
  private disableDateInput?: boolean;

  @Prop()
  private isEventOnMultipleDates?: boolean;

  get is_using_default_interval(): boolean {
    return this.dates.length === 1;
  }

  get interval_names(): Array<string> {
    return ['Coffee-Break', 'Lunch', 'Brunch', 'Café', 'Pausa', 'Almoço'];
  }

  getLabel(index: number): string {
    const indexLabel: string = `${index + 1}`;
    return `${(!this.interval && `${indexLabel}ª DATA`) || ''}`;
  }

  hideDateRange(dateRange: DateRange): boolean {
    return this.isDateRangeCompleted(dateRange) && (dateRange as any).hidden !== false;
  }

  isDateRangeSameDay(date: DateRange): boolean {
    return EventDateHelper.isSameDay(date);
  }

  getFormattedDate(date: string): string {
    const momentDate = moment(date);
    return momentDate.format('DD/MM/YYYY');
  }

  getDate(date: DateRange, index: number): string {
    const isStartHourNotFilled = {
      ...this.$refs[`dateRangePicker_${index}`],
    }?.[0]?.isStartHourNotFilled();
    const isEndHourNotFilled = {
      ...this.$refs[`dateRangePicker_${index}`],
    }?.[0]?.isEndHourNotFilled();
    const momentDateStart = moment(date.start);
    const momentDateEnd = moment(date.end);
    return (
      (date.start &&
        date.end &&
        ` ( ${this.getFormattedDate(date.start)}${
          !this.isDateRangeSameDay(date) ? ` - ${this.getFormattedDate(date.end)}` : ''
        } | ${isStartHourNotFilled ? '-' : momentDateStart.format('HH:mm')} à ${
          isEndHourNotFilled ? '-' : momentDateEnd.format('HH:mm')
        } )`) ||
      ''
    );
  }

  isDateRangeCompleted(dateRange: DateRange): boolean {
    return !!(dateRange.start && dateRange.end);
  }

  @Emit()
  onChangeDefaultInterval($event: any, index: number): { checked: boolean; dateRange: DateRange } {
    return { checked: !!$event.target?.checked, dateRange: this.dates[index] };
  }

  onUpdateInfoDatesStart(isoDate: string, index: number): Array<DateRange> {
    this.dates.splice(index, 1, Object.assign(this.dates[index], { start: isoDate }));
    if (this.parentInfo) {
      // const newEndDay: string = moment(this.dates[index].end).date(moment(isoDate).date()).toISOString();
      return this.onUpdateInfoDatesEnd(isoDate, index);
    }
    return this.onUpdateDates();
  }

  onUpdateInfoDatesEnd(isoDate: string, index: number): Array<DateRange> {
    this.dates.splice(index, 1, Object.assign(this.dates[index], { end: isoDate }));
    return this.onUpdateDates();
  }

  onExcludeDate(index: number): Array<DateRange> {
    this.dates.splice(index, 1);
    return this.onUpdateDates();
  }

  onSubmitDate(index: number): Array<DateRange> {
    this.dates.splice(index, 1, Object.assign(this.dates[index], { hidden: undefined }));
    return this.onUpdateDates();
  }

  onExpandDateRange(index: number): Array<DateRange> {
    this.dates.splice(index, 1, Object.assign(this.dates[index], { hidden: false }));
    return this.onUpdateDates();
  }

  @Emit()
  onUpdateDates() {
    return this.dates;
  }
}
